<template>
  <v-form>
    <v-row align="center" justify="center">
      <h3><b>{{$t('json.importsettings')}}</b></h3>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12"><v-text-field :disabled="disable || preview" @change="onChange" v-model="props.ImportSettings.ImportFolder" :label="$t('json.appImportFolder')"></v-text-field></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="onChange" v-model="props.ImportSettings.DeleteFileAfterImport" :label="$t('json.deletefileafterimport')"></v-switch></v-col>
      <v-col cols="12"><v-switch :disabled="disable || preview" @change="onChange" v-model="props.ImportSettings.ForceImportFolder" :label="$t('json.forceimportfolder')"></v-switch></v-col>
      <!-- <v-col cols="12"><v-switch :disabled="disable || preview" @change="onChange" v-model="props.ImportSettings.Attachments" :label="$t('json.appAttachments')"></v-switch></v-col> -->
    </v-row>
  </v-form>
</template>

<script>

export default {
  name: 'ImportSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { }
  },
  methods: {
    async onChange (val) {
      this.$emit('changeSettings')
    }
  }
}
</script>
